<template>
  <v-container class="authRegionMain">
    <v-row>
      <v-col cols="8" class="pt-0">
        <v-select
          v-model="selectedRegion"
          :items="envOptions"
          item-text="name"
          item-value="name"
        ></v-select>
      </v-col>
      <v-col cols="2" class="pt-0">
        <v-btn @click="selectAuthRegion">SUBMIT</v-btn>
      </v-col>
      <v-col cols="2" class="pt-0">
        <v-btn @click="resetDesiredAuthRegion">reset</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import lodashGet from "lodash/get";
import { AUTH0_TENANT_CONFIGS } from "@/common/config";
import { setDesiredAuthRegion } from "@/common/authenticate";

//This page is a proof of concept for differentiating auth0 regions based on a cookie

export default {
  name: "AuthRegion",
  data: () => {
    return {
      selectedRegion: null,
    };
  },
  methods: {
    selectAuthRegion() {
      setDesiredAuthRegion(this.selectedRegion);
      let redirect = lodashGet(this, "$route.query.redirect") || "/";
      window.location = redirect;
    },
    resetDesiredAuthRegion() {
      setDesiredAuthRegion("");
    },
  },
  computed: {
    envOptions() {
      return AUTH0_TENANT_CONFIGS;
    },
  },
};
</script>

<style scoped>
.authRegionMain {
  background-color: white;

  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);
  top: 50%;
}
</style>
